export const calculateBounds = (features) => {
    let minLon = Infinity, minLat = Infinity, maxLon = -Infinity, maxLat = -Infinity;
  
    features.forEach(feature => {
      const coordinates = feature.geometry.coordinates.flat(Infinity);
  
      for (let i = 0; i < coordinates.length; i += 2) {
        const lon = coordinates[i];
        const lat = coordinates[i + 1];
  
        if (lon < minLon) minLon = lon;
        if (lat < minLat) minLat = lat;
        if (lon > maxLon) maxLon = lon;
        if (lat > maxLat) maxLat = lat;
      }
    });
  
    return {
      minLon,
      minLat,
      maxLon,
      maxLat
    };
  };
